var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.428711,
    y: -0.000488281,
    width: 41.573,
    height: 40,
    rx: 20,
    fill: "#D4ADF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4187 9.99951H30.7267L23.4997 18.2595L32.0017 29.4995H25.3447L20.1307 22.6825L14.1647 29.4995H10.8547L18.5847 20.6645L10.4287 9.99951H17.2547L21.9677 16.2305L27.4187 9.99951ZM26.2577 27.5195H28.0907L16.2587 11.8755H14.2917L26.2577 27.5195Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.cae58e8dce9c3f6f74b9eb18b0740dda.svg";
export { ForwardRef as ReactComponent };